import { type Context, createContext } from 'react';
import { type Avatar } from './Avatar';

export const AssistantAvatarContext: Context<Avatar> = createContext({
  altText: 'The Outpace logo',
  uri: '/images/webclip.png',
});
AssistantAvatarContext.displayName = 'AssistantAvatarContext';
